export default "/images/66d3f36539736499def76a8e29553df4.avif";